import { render, staticRenderFns } from "./adminDialogByRole.vue?vue&type=template&id=186df2fa&scoped=true&params=type"
import script from "./adminDialogByRole.vue?vue&type=script&lang=js"
export * from "./adminDialogByRole.vue?vue&type=script&lang=js"
import style0 from "./adminDialogByRole.vue?vue&type=style&index=0&id=186df2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186df2fa",
  null
  
)

export default component.exports